<template>
  <div v-if="$route">
    <div v-show="!shouldHideParent">
      <slot></slot>
    </div>
    <transition appear name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseSubRouteContainer',
  computed: {
    shouldHideParent () {
      const containers = this.getContainers()
      const ms = this.$route.matched
      const m = ms[ms.length - 1]
      const len = containers.length - 1
      let p = m
      for (let i = 0; i < len; i++) {
        p = p.parent
        if (p == null) break
      }
      return p && p.path
    }
  },
  methods: {
    getContainers () {
      let p = this
      const result = [this]
      while (p) {
        if (p.$options.name === 'BaseSubRouteContainer') result.push(p)
        p = p.$parent
      }
      return result
    }
  }
}
</script>
